module.exports = __webpack_public_path__ + "img/nfc-pen.e883d02c.svg";